const removeLocalStorage = key => {
	localStorage.removeItem(key);
};

export default removeLocalStorage;
